import { SaleBadgeProps } from '../../types';
import whisperBadge from 'assets/Whisper/sale-badge.png';
import { StyledWhisperSaleBadge, StyledWhisperSaleBadgeNumber } from './style';
import { useMemo } from 'react';

export const WhisperSaleBadge = ({ salePercentage }: SaleBadgeProps) => {
  const digitsNumber = useMemo(
    () => salePercentage.toString().length,
    [salePercentage],
  );
  return (
    <StyledWhisperSaleBadge>
      <img src={whisperBadge} alt="sale-badge" />
      <StyledWhisperSaleBadgeNumber digitsNumber={digitsNumber}>
        {salePercentage}
      </StyledWhisperSaleBadgeNumber>
    </StyledWhisperSaleBadge>
  );
};
